import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress benign ResizeObserver loop error (common with DataGrid, Accordion, modals)
const resizeObserverErr = window.onerror;
window.onerror = function (message, ...rest) {
  if (message === 'ResizeObserver loop completed with undelivered notifications.') {
    return true;
  }
  return resizeObserverErr ? resizeObserverErr.apply(this, [message, ...rest]) : false;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
